//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["controlItem", "onConfirmCilck"],
  data() {
    return {
      showPicker: false,

      ThisName: "",
      ThisItem: {},

      DataList: [],
      ColumnNameList: []
    };
  },
  created() {
    this.initData();
  },

  watch: {
    controlItem(val) {
      console.log("watch--controlItem", val);
      this.initData();
    }
  },

  methods: {
    initData() {
      if (
        this.controlItem &&
        this.controlItem.ChildList &&
        this.controlItem.ChildList.length > 0
      ) {
        this.DataList = this.controlItem.ChildList;
        this.ColumnNameList = this.controlItem.ChildList.map(m => m.Text);

        var dataItem = this.controlItem.ChildList.find(
          m => m.Value == this.controlItem.ControlValue
        );
        if (dataItem) {
          this.ThisName = dataItem.Text;
          this.ThisItem = dataItem;
        }else{
          this.ThisName = '';
          this.ThisItem = {};
        }
      }
    },

    onPickerClick() {
      console.log("onPickerClick");
      this.showPicker = true;
    },

    onConfirm(value, index) {
      console.log(value);
      this.ThisName = value;
      this.ThisItem = null;

      if (index >= 0) {
        this.ThisItem = this.DataList[index];
        this.controlItem.ControlValue = this.ThisItem.Value;
        this.controlItem.ControlName = this.ThisItem.Text;
      }
      console.log("this.ThisItem ", this.ThisItem);
      this.showPicker = false;

      this.$emit("onConfirmCilck", this.controlItem, this.ThisItem);
    },

    onHelpIconClick($event) {
      console.log("OnHelpIconClick-$event", $event);
      if (this.controlItem && this.controlItem.HelperText) {
        this.$msg.toast(this.controlItem.HelperText);
      } else {
        this.$msg.toast("没有找到帮助信息");
      }
    }
  }
};
